/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var STORE_DOWNTIME_DD_REASON_CATEGORIES;
(function (STORE_DOWNTIME_DD_REASON_CATEGORIES) {
    STORE_DOWNTIME_DD_REASON_CATEGORIES["PAUSED"] = "paused";
    STORE_DOWNTIME_DD_REASON_CATEGORIES["INACTIVE"] = "inactive";
    STORE_DOWNTIME_DD_REASON_CATEGORIES["DEACTIVATED"] = "deactivated";
    STORE_DOWNTIME_DD_REASON_CATEGORIES["CLOSED"] = "closed";
})(STORE_DOWNTIME_DD_REASON_CATEGORIES || (STORE_DOWNTIME_DD_REASON_CATEGORIES = {}));
